import {
  IConnectionConfigEnvironment,
  IConnectionTypes,
  IPartnerApplicationTypes,
} from 'types/graphqlTypes'
import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const AddInboundConnectionConfigModalSchema = yup.object({
  /**
   * @example '4'
   */
  id: yup.string(),
  /**
   * @example { id: '1241', text: '1720-shipper', data: { __typename: 'ShipperApplication' } }
   */
  company: yup
    .object({
      id: yup.string(),
      text: yup.string(),
      data: yup.object({
        __typename: yup
          .mixed<IPartnerApplicationTypes>()
          .oneOf([...Object.values(IPartnerApplicationTypes)]),
      }),
    })
    .required(REQUIRED_MESSAGE),
  /**
   * @example 'SFTP_WITH_PASSWORD'
   */
  connectionType: yup
    .mixed<IConnectionTypes>()
    .oneOf([...Object.values(IConnectionTypes)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example true
   */
  disabled: yup.boolean().default(true).required(REQUIRED_MESSAGE),
  /**
   * @example 'production'
   */
  environment: yup
    .mixed<IConnectionConfigEnvironment>()
    .oneOf([...Object.values(IConnectionConfigEnvironment)])
    .required(REQUIRED_MESSAGE),
  /**
   * @example 'edi-file-server.transfix.io'
   */
  host: yup.string(),
  /**
   * @example '22'
   */
  port: yup.number(),
  /**
   * @example 'tfxh-1edi'
   */
  username: yup.string(),
  /**
   * @example 'EDI_AWS_SECRET_KEY'
   */
  secretKey: yup.string(),
  /**
   * @example 'PROD/FromMtd/' | 'PROD/ToMtd/'
   */
  pathPrefix: yup.string(),
  /**
   * @example '*'
   */
  filenameGlob: yup.string(),
  /**
   * @example 2
   */
  as2ConnectionConfigId: yup.string(),
  /**
   * @example true
   */
  send997s: yup.boolean().default(true).required(REQUIRED_MESSAGE),
})

export type TAddInboundConnectionConfigModalSchema = yup.InferType<
  typeof AddInboundConnectionConfigModalSchema
>
